import React, { Component } from 'react'
import { Field } from 'redux-form'
import classnames from 'classnames'

export interface Option {
  label: string
  requiredBadge?: string[]
  taskBucket?: string
  value: string
}

export interface Props {
  currentUserBadges?: string[]
  gridClass?: string
  gridColumn?: boolean
  gridRow?: boolean
  options: Option[] | null
  name?: string
}

export default class CheckboxGroup extends Component<Props> {
  field = ({ input, meta, options, currentUserBadges }) => {
    const { name, onChange, onBlur, onFocus } = input
    const { error, submitFailed } = meta
    const inputValue = input.value

    const checkboxes = options.map(
      ({ label, value, requiredBadge, taskBucket }, index) => {
        const hasNoMatchingBadge = () => {
          if (currentUserBadges && requiredBadge) {
            return !currentUserBadges.includes(
              requiredBadge.toString().toUpperCase()
            )
          } else return false
        }

        const handleChange = (event) => {
          const inputValues = [...inputValue]
          if (event.target.checked) {
            inputValues.push(value)
          } else {
            inputValues.splice(inputValues.indexOf(value), 1)
          }
          onBlur(inputValues)
          return onChange(inputValues)
        }

        const checked = inputValue.includes(value)

        return (
          <div
            className={classnames({
              [`form__checkbox--${taskBucket}`]: taskBucket,
            })}
            key={`checkbox-${name}[${index}]`}
          >
            <input
              type="checkbox"
              name={`${name}[${index}]`}
              id={`checkbox-${name}[${index}]`}
              value={value}
              checked={checked}
              onChange={handleChange}
              onFocus={onFocus}
              disabled={hasNoMatchingBadge()}
              className={classnames('form__checkbox', {
                'form__checkbox--disabled': hasNoMatchingBadge(),
                'form__control--error': submitFailed && error,
              })}
            />
            <label
              className={classnames({
                'form__control--disabled-text': hasNoMatchingBadge(),
              })}
              htmlFor={`checkbox-${name}[${index}]`}
            >
              {label}
            </label>
          </div>
        )
      }
    )

    const taskCheckboxes = options[0].hasOwnProperty('taskBucket')
    const { gridRow } = this.props

    return (
      <div
        className={classnames('form__checkbox-group-wrapper', {
          'form__checkbox-group-wrapper--row': gridRow,
          'form__checkbox-group-wrapper--tasks': taskCheckboxes,
        })}
      >
        {checkboxes}
        {submitFailed && error && (
          <p className="form__help-text text-error">{error}</p>
        )}
      </div>
    )
  }

  render() {
    return <Field {...this.props} type="checkbox" component={this.field} />
  }
}
